import { Component } from '@angular/core';

@Component({
  selector: 'app-flock',
  templateUrl: './flock.component.html',
  standalone: false,
})
export class FlockComponent {}
